(function () {
  var TGTP_TENANTS = window.__tgtpTenantData;
  var tenant = window.__tgtpResolvedTenant || '';
  var isHomePage = window.__tgtpIsHome || false;

  // Liquid 側で解決済みのテナントが tenantData に存在しない場合はフォールバック
  if (tenant && !TGTP_TENANTS[tenant]) {
    tenant = '';
  }
  if (!tenant && TGTP_TENANTS['top']) {
    tenant = 'top';
  }

  // CSS 変数を適用
  if (tenant) {
    var cfg = TGTP_TENANTS[tenant];
    var colors = (isHomePage && cfg.home) ? cfg.home : cfg;
    var root = document.documentElement.style;
    if (colors.header)             root.setProperty('--tgtp-color-header', colors.header);
    if (colors.on_header)          root.setProperty('--tgtp-color-on-header', colors.on_header);
    if (colors.primary)            root.setProperty('--tgtp-color-primary', colors.primary);
    if (colors.surface)            root.setProperty('--tgtp-color-surface', colors.surface);
    if (colors.on_surface)         root.setProperty('--tgtp-color-on-surface', colors.on_surface);
    if (colors.on_primary)         root.setProperty('--tgtp-color-on-primary', colors.on_primary);
    if (colors.outline)            root.setProperty('--tgtp-color-outline', colors.outline);
    if (colors.secondary)          root.setProperty('--tgtp-color-secondary', colors.secondary);
    if (colors.container)          root.setProperty('--tgtp-color-container', colors.container);
    if (colors.on_container)       root.setProperty('--tgtp-color-on-container', colors.on_container);
    if (colors.surface_scrim)      root.setProperty('--tgtp-color-surface-scrim', colors.surface_scrim);
    if (colors.on_surface_scrim)   root.setProperty('--tgtp-color-on-surface-scrim', colors.on_surface_scrim);
    if (colors.footer)             root.setProperty('--tgtp-color-footer', colors.footer);
    if (colors.on_footer)          root.setProperty('--tgtp-color-on-footer', colors.on_footer);

    if (colors.bg_image) {
      root.setProperty('--tgtp-bg-image', 'url(' + colors.bg_image + ')');
    }
    if (colors.bg_image_mobile) {
      root.setProperty('--tgtp-bg-image-mobile', 'url(' + colors.bg_image_mobile + ')');
    }
  }

  window.__tgtpTenant = tenant;
  window.__tgtpTenants = TGTP_TENANTS;
})();
